export default "./images/survio-A266K-assets-activity-member-24.svg";